import React from "react";
import styles from "./css/ReviewCoursePage.module.css";

const ReviewCoursePage = () => {
  return <div className={styles.main}>ReviewCoursePage</div>;
};

export default ReviewCoursePage;
